import { useParams } from 'react-router-dom';
import { EnrollmentFlowDomainParams } from 'store/flows/enrollment/enrollmentFlowPage';

export const useEnrollmentDomainParams = (): EnrollmentFlowDomainParams => {
  const { groupId, periodId } = useParams<{ groupId: string; periodId: string }>();
  if (!groupId || !periodId) {
    throw new Error(
      `useEnrollmentDomainParams was not able to find all required params in the url! Found: groupId: ${groupId}, periodId: ${periodId}`,
    );
  }
  return { groupId, periodId };
};
